import { render, staticRenderFns } from "./title08-view.html?vue&type=template&id=6cc5f5b4&"
import script from "./title08-view.js?vue&type=script&lang=js&"
export * from "./title08-view.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports